// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".model-preview[data-v-eaccf5b4]{width:100%}.model-preview[data-v-eaccf5b4] .main-wrap{height:calc(100vh - 175px)!important;padding:0}", ""]);
// Exports
module.exports = exports;
